import { Link } from "react-router-dom";
import BlogSection from "../components/BlogSection";

function Blog() {
  return (
    <div>
      {
		<>		
		<section className="page-title custom-breadcrumb">
			<div className="overlay"></div>
			<div className="auto-container">
				<div className="content-box">
					<h1>Blog Page</h1>
					<ul className="bread-crumb"><li><Link to="/">Home</Link></li><li><span>→</span></li><li className="active">Blog</li></ul>
				</div>
			</div>
		</section>	
		
		<BlogSection />;
		</>
	  }
    </div>
  );
}

export default Blog;